export const RECURLY_KEY = process.env.REACT_APP_RECURLY_KEY || '';
export const DEFAULT_BUNDLE_ID = 'default';
